<template>
  <section class="contact-details">
    <div class="container">
      <SectionHeader title="Contact Us" :description="description" />
      <a-row :gutter="32">
        <a-col :sm="8" :key="index" v-for="(info, index) in contactData">
          <div
            data-aos="zoom-in"
            data-aos-duration="600"
            :data-aos-delay="200 * index"
            class="contact-info"
          >
            <div class="icon-wrap">
              <a-icon :type="info.icon" />
            </div>
            <div class="text-content">
              <div class="info-title">
                {{ info.title }}
              </div>
              <div class="info-details">
                <a :href="info.href" target="_blank">
                  {{ info.detail }}
                </a>
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
  </section>
</template>

<script>
import SectionHeader from "@/pageComponents/globalUi/section-header";

export default {
  name: "ContactDetail",
  components: {
    SectionHeader
  },
  props: {
    contactData: {
      type: Array,
      default: () => []
    },
    description: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variable.scss";
@import "@/scss/_mixins.scss";
.contact-details {
  padding-top: 0px;
  .contact-info {
    display: flex;
    align-items: center;
    width: fit-content;
    margin: 0 auto;
    .icon-wrap {
      width: 50px;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background: $brand-color;
      .anticon {
        color: #fff;
        font-size: 18px;
      }
    }
    .text-content {
      padding-left: 20px;
      .info-title {
        font-family: $content-font;
        font-size: 12px;
        font-weight: 500;
        color: #000;
        margin-bottom: 5px;
      }
      .info-details {
        a {
          font-family: $content-font;
          font-weight: 600;
          font-size: 16px;
          color: $secondary-color;
        }
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .contact-details {
    .contact-info {
      flex-direction: column;
      .text-content {
        padding-left: 0;
        padding-top: 10px;
        text-align: center;
      }
    }
  }
}

@media only screen and (max-width: 575px) {
  .contact-details {
    .contact-info {
      padding-bottom: 20px;
    }
  }
}
</style>
